import { ReactComponent as IconQuote } from '@mnd-frontend/ui/shared/svgs/quote.svg';
import {
  BREAKPOINTS,
  SIZING_4,
  SIZING_7,
  SPACING_2,
  SPACING_3,
} from '@mnd-frontend/ui/shared/tokens';
import Image from 'next/image';
import styled from 'styled-components';
import Badge from '../Badge';
import CardBase from '../CardBase';

// #region styled components
const Card = styled(CardBase)`
  background: #ffffff;
  width: calc(100vw - 2rem);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${SPACING_3};
  padding: ${SPACING_2};
  flex-shrink: 0;

  @media (min-width: ${BREAKPOINTS.XS}px) {
    width: 100%;
    padding: ${SPACING_3};
  }

  @media (min-width: ${BREAKPOINTS.SM}px) {
    width: 22rem;
  }

  @media (min-width: ${BREAKPOINTS.LG}px) {
    width: 24.5rem;
  }
`;

const Quote = styled.p` //@todo: web/quote/desktop
  font-size: 1.5rem; // @todo: web/purple/reg
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
  margin: 0;

  @media (min-width: ${BREAKPOINTS.XS}px) { //@todo:  web/quote/mobile
    font-size: 2rem;
    letter-spacing: -0.06rem;
  }
`;

const ContentMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_3};
`;

const Contact = styled.div<{ $hasImage?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hasImage }) =>
    $hasImage ? `${SIZING_7} 1fr ${SIZING_4}` : `1fr ${SIZING_4}`};
  gap: ${SPACING_2};
  align-items: center;
`;

const ImageWrapper = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  overflow: hidden;

  img {
    object-fit: cover;
  }
`;

const Name = styled.span` //@todo: web/body/highlight
  font-size: 1rem;
  font-weight: 600;
  line-height: 150%;
  margin: 0;
`;

const JobTitle = styled.span` //@todo: web/body/reg
  font-size: 1rem;
  font-weight: 400;
  line-height: 150%;
  display: block;
  margin: 0;
`;
// #endregion

type CardQuotationProps = {
  quote: string | null;
  organisation: string | null;
  name: string | null;
  jobTitle?: string | null;
  profileImage?: string | null;
};

const CardQuotation = ({
  quote,
  organisation,
  name,
  jobTitle,
  profileImage,
}: CardQuotationProps) => (
  <Card>
    <ContentMain>
      <Badge text={organisation} />
      <Quote>{quote}</Quote>
    </ContentMain>
    <Contact $hasImage={!!profileImage}>
      {profileImage && (
        <ImageWrapper>
          <Image width={56} height={56} alt="" src={profileImage} />
        </ImageWrapper>
      )}
      <div>
        <Name>{name}</Name>
        {jobTitle && <JobTitle>{jobTitle}</JobTitle>}
      </div>
      <IconQuote style={{ width: 32 }} aria-hidden />
    </Contact>
  </Card>
);

export default CardQuotation;
